import { writable } from "svelte/store";

export const cookieConsentStore = writable({
  shown: false,
  hasConsented: false,
  preferences: {
    necessary: true, // Always true, can't be disabled
    analytics: true,
    advertising: true,
  },
});
